// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="stopHoldHeader">Unable to Register Property</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="stopHoldBody">Unfortunately, we are unable to register this property. Please contact your property management company. {{ data.reasonCode }}</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130" tid="stopHoldClose" (click)="closeThisDialog(0)">Close</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;